import { axios } from '@Root/API'

export const create = (studyProgrammeId, payload) => {
	return axios.post(`course-session/${studyProgrammeId}/session-status`, payload)
}
